"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectFilterGenerator = void 0;
const core_types_1 = require("@dqm/core-types");
const Expression_1 = require("./Expression");
const UnsupportedOperatorError_1 = require("./UnsupportedOperatorError");
class ObjectFilterGenerator {
    generateCompositeFilter(expression, compiler) {
        if (!(0, Expression_1.isCompositeExpression)(expression)) {
            throw new core_types_1.ArgumentError("generateCompositeFilter: invalid composite expression");
        }
        if (expression.operands.length === 0) {
            throw new core_types_1.ArgumentError("generateCompositeFilter: missing operands");
        }
        switch (expression.operator) {
            case "and":
                return this.createAndFilter(expression, compiler);
            case "or":
                return this.createOrFilter(expression, compiler);
        }
        throw new UnsupportedOperatorError_1.UnsupportedOperatorError();
    }
    generateComparisonFilter(expression) {
        if (!(0, Expression_1.isComparisonExpression)(expression)) {
            throw new core_types_1.ArgumentError("generateComparisonFilter: invalid comparison expression");
        }
        switch (expression.operator) {
            case "eq":
                return this.createEqFilter(expression);
            case "neq":
                return this.createNeqFilter(expression);
            case "lte":
                return this.createLteFilter(expression);
            case "gte":
                return this.createGteFilter(expression);
            case "in":
                return this.createInFilter(expression);
            case "count":
                return this.createCountFilter(expression);
        }
        throw new UnsupportedOperatorError_1.UnsupportedOperatorError();
    }
    createAndFilter(expression, compiler) {
        return (item) => {
            for (const operand of expression.operands) {
                const filter = compiler.compile(operand);
                if (!filter(item)) {
                    return false;
                }
            }
            return true;
        };
    }
    createOrFilter(expression, compiler) {
        return (item) => {
            for (const operand of expression.operands) {
                const filter = compiler.compile(operand);
                if (filter(item)) {
                    return true;
                }
            }
            return false;
        };
    }
    createCountFilter(expression) {
        return (item) => {
            if (!this.checkValidItem(item, expression.field, typeof []) ||
                !Array.isArray(item[expression.field])) {
                return false;
            }
            return item[expression.field].length === expression.value;
        };
    }
    createLteFilter(expression) {
        return (item) => {
            if (!this.checkValidItem(item, expression.field, typeof expression.value)) {
                return false;
            }
            return item[expression.field] <= expression.value;
        };
    }
    createGteFilter(expression) {
        return (item) => {
            if (!this.checkValidItem(item, expression.field, typeof expression.value)) {
                return false;
            }
            return item[expression.field] >= expression.value;
        };
    }
    createEqFilter(expression) {
        return (item) => {
            if (!this.checkValidItem(item, expression.field, typeof expression.value)) {
                return false;
            }
            return expression.value === item[expression.field];
        };
    }
    createNeqFilter(expression) {
        const eqFilter = this.createEqFilter(expression);
        return (item) => {
            return !eqFilter(item);
        };
    }
    createInFilter(expression) {
        return (item) => {
            if (!this.checkValidItem(item, expression.field, typeof []) ||
                !Array.isArray(item[expression.field])) {
                return false;
            }
            return item[expression.field].includes(expression.value);
        };
    }
    checkValidItem(item, field, type) {
        if (!(0, core_types_1.isObject)(item)) {
            return false;
        }
        if (!(field in item)) {
            return false;
        }
        return type === typeof item[field];
    }
}
exports.ObjectFilterGenerator = ObjectFilterGenerator;
//# sourceMappingURL=ObjectFilterGenerator.js.map